/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PostTemplatesRoute extends Route {
  queryParams = {
    pageType: {
      refreshModel: true,
      as: 'type',
    },
    jurisdiction: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let postTemplateParams = {
      type: params.pageType,
    };
    if (!isEmpty(params.jurisdiction)) {
      postTemplateParams.jurisdiction = params.jurisdiction;
    }

    return hash({
      fieldTemplateSets: store.findAll('people-schema/set'),
      fieldGroups: store.findAll('people-schema/group'),
      fields: store.findAll('people-schema/field'),
      postTemplates: store.query('posts/post-template', postTemplateParams),
      schoolGroups: this.store.findAll('schools/group'),
      schools: this.store.findAll('school'),
    });
  }
}
